import React, { useEffect, useState } from 'react';
import './Header.css';
import logooficial from '../assets/images/norea.png'; // Caminho da logo principal
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faBell } from '@fortawesome/free-solid-svg-icons';  

function Header({ handleLogout }) {
    const [userInfo, setUserInfo] = useState({ nome: '', logo: '' });

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const response = await fetch('https://welaunchyou.com.br/crm-wly/getUserInfo.php', {
                    credentials: 'include',
                });

                if (response.ok) {
                    const data = await response.json();
                    const avatarPath = data.logo
                        ? `https://welaunchyou.com.br/crm-wly/${data.logo.replace(/\\/g, '/')}`
                        : '';
                    setUserInfo({ ...data, logo: avatarPath });
                } else {
                    console.error('Erro ao buscar informações do usuário:', response.statusText);
                }
            } catch (error) {
                console.error('Erro ao buscar informações do usuário:', error);
            }
        };

        fetchUserInfo();
    }, []);

    const handleNotificationClick = () => {
        alert("Sem notificações");
    };

    return (
        <header className="header">
            <div className="header-content">
                <img src={logooficial} alt="Logo Nórea CRM" className="logooficial" />
                <h1 className="header-title">CRM</h1>
            </div>
            <div className="header-user-actions">
               {/* Avatar */}
                {userInfo.logo && (
                    <div className="header-avatar">
                        <img
                            src={userInfo.logo}
                            alt={`Avatar de ${userInfo.nome}`}
                            className="avatar"
                        />
                    </div>
                )}
                     {/* Ícone de Notificação */}
                     <FontAwesomeIcon
                    icon={faBell}
                    className="notification-icon"
                    title="Notificações"
                    onClick={handleNotificationClick}
                />
                {/* Ícone de Logout */}
                <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="logout-icon"
                    title="Sair"
                    onClick={handleLogout}
                />

            </div>
        </header>
        
    );
}

export default Header;
